





































































import {Component, Mixins} from 'vue-property-decorator';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import SelectDialogMixin from '@/components/dialog/SelectDialogMixin';
import DefaultComponentMixin from '@/views/DefaultComponentMixin';
import DefaultFormMixin from '@/views/DefaultFormMixin';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import {AdminRolesListInfo, CaseWorkflowBatchUpdateDialogRequest, Workflow, WorkflowInfo} from '@/model/CommonModel';
import SelectInput from '@/components/input/SelectInput.vue';
import CommonValidators from '@/validator/CommonValidators';
import CaseApi from '@/api/CaseApi';
import AutocompleteInput from '@/components/input/AutocompleteInput.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import TextInput from '@/components/input/TextInput.vue';

@Component({
  components: {TextInput, AutocompleteInput, SelectInput, CommonPromptDialog, CommonButton},
  mixins: [DialogEventsMixin, SelectDialogMixin, DefaultComponentMixin, DefaultFormMixin]
})
export default class CaseWorkflowBatchUpdateDialog
    extends Mixins(DialogEventsMixin, SelectDialogMixin, DefaultComponentMixin, DefaultFormMixin) {
  protected width: string = '800px';
  private onConfirm: (row: any) => void;
  private workflow: WorkflowInfo = {
    workflowKey: 0,
    workflowLabel: '',
    roleId: '',
    userKey: '',
    requestTime: '',
  };
  private sponsorWorkflows: Workflow[] = [];
  private sponsorWorkflowRoles: AdminRolesListInfo[] = [];
  private sponsorWorkflowRoleUsers: any[] = [];

  private LABEL_WIDTH = '230px';
  private CONTENT_WIDTH = '50%';

  private form = {
    data: {
      workflowInfo: {
        workflowKey: '',
        workflowLabel: '',
        roleId: '',
        roleLabel: '',
        userKey: '',
        userName: '',
      },
      comments: '',
    },
    rules: {
      workflowKey: {validator: CommonValidators.required(this), trigger: 'submit'},
      comments: {validator: CommonValidators.required(this), trigger: 'submit'},
    }
  };

  get getTitle() {
    return this.$t('message.batchWorkflowDialog.title');
  }

  get currentWorkflowLabel() {
    return this.workflow.workflowLabel;
  }

  get isVisible() {
    return this.visible;
  }

  get isRoleSelectDisabled() {
    return this.isFormDisabled || !this.form.data.workflowInfo.workflowKey;
  }

  get isUserSelectDisabled() {
    return this.isFormDisabled || !this.form.data.workflowInfo.roleId;
  }

  public mounted() {
    this.$modal
        .getEventBus()
        .$on('showCaseWorkflowBatchUpdateDialog', (params: CaseWorkflowBatchUpdateDialogRequest) => {
          this.show(params);
        });

    this.$modal.getEventBus().$on('hideCaseWorkflowBatchUpdateDialog', () => this.close());
  }


  public show(params: CaseWorkflowBatchUpdateDialogRequest) {
    this.workflow = params.currentWorkflow;
    this.sponsorWorkflows = params.workflows;
    this.onConfirm = params.onConfirm;
    this.visible = true;
    this.loading = false;
  }

  public onOk() {
    const {workflowKey, roleId} = this.form.data.workflowInfo;
    this.form.data.workflowInfo.workflowLabel = this.sponsorWorkflows
        .find((w: any) => w.workflowKey === workflowKey)
        ?.workflowLabel ?? '';
    this.form.data.workflowInfo.roleLabel = this.sponsorWorkflowRoles
        .find((role) => role.ROLE_ID === roleId)?.ROLE_NAME ?? '';

    this.validation(() => this.onConfirm(this));
  }

  public close() {
    this.visible = false;
  }

  public getData() {
    return this.form.data;
  }


  public beforeApiCall() {
    this.loading = true;
  }

  public afterApiCall() {
    this.close();
    this.loading = false;
  }

  public afterClosed() {
    this.sponsorWorkflows = [];
    this.sponsorWorkflowRoles = [];
    this.sponsorWorkflowRoleUsers = [];
    this.form.data = {
      workflowInfo: {
        workflowKey: '',
        workflowLabel: '',
        roleId: '',
        roleLabel: '',
        userKey: '',
        userName: '',
      },
      comments: '',
    };
    this.loading = false;
  }

  public onWorkflowChange(data: any) {
    if (this.form.data.workflowInfo.roleId) {
      this.form.data.workflowInfo.roleId = '';
    }
    this.form.data.workflowInfo.userKey = '';
    const workflow = this.sponsorWorkflows.find((w: any) => w.workflowKey === data);
    this.sponsorWorkflowRoles = workflow?.roles ?? [];
  }

  public onWorkflowRoleChange(roleId: any) {
    this.form.data.workflowInfo.userKey = '';
    if (!roleId) {
      return;
    }

    CaseApi.retrieveUsersByRoleId(roleId)
        .then((res: any) => {
          if (!res.success) {
            return Promise.reject(res.errMsg);
          }
          this.sponsorWorkflowRoleUsers = res.data;
        }).catch((errMsg) => this.afterRequestFail(errMsg));
  }
}
